<template>
  <div class="popularity-wrap container flex">
    <div class="popular-list" :class="{ 'popular-listen': langSet != 'cn' }">
      <div
        class="popu-item flex flex_items_center flex_content_sb"
        v-for="(item, index) in list"
        :key="index"
        @click="toDetails(item)"
      >
        <span class="rank">{{ index + 1 }}</span>
        <div class="pop-logo flex flex_items_center flex_content_center">
          <img class="img" :src="item.logo" />
        </div>
        <span class="p-name">{{
          langSet == "cn" ? item.companyName : item.enCompanyName
        }}</span>
        <!-- 26.1.5 隐藏展位号 dxm -->
        <!-- <span class="p-num" v-if="item.boothNo">{{ item.boothNo }}</span> -->
      </div>
    </div>
    <div class="popular-right">
      <div class="popu-intro" :class="{ 'popu-intro-en' : langSet != 'cn' }">
        {{
          langSet == "cn"
            ? "想知道哪些产品最受关注、哪家企业店铺备受关注，人气爆棚吗？API制药家平台依托企业店铺及产品的浏览数据，重磅推出产品与企业店铺热度榜！实时呈现热门趋势，为您快速锁定行业热点，点击查看，抢占合作先机！"
            : "You want to know which products are the most popular, or which stores are attracting the most attention? The API PharmHome platform proudly launches the Product and Enterprise Store Popularity Rankings, powered by real-time browsing data! Stay informed of the latest industry trends at a glance, identify hot products and top-performing companies instantly. Click to explore and stay at the forefront of the pharmaceutical market!"
        }}
      </div>
      <div class="popu-ewm">
        <el-image
          style="width: 228px; height: 228px"
          :src="ewm"
          :fit="'fill'"
        ></el-image>
        <p v-if="langSet == 'cn'">扫描小程序码<br />查看更多优质展商</p>
        <p v-else>Scan the QR code to discover more quality exhibitors.</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
    },
  },
  components: {},
  data() {
    return {
      langSet: "",
      ewm: require("../../../assets/ewm.jpg"),
    };
  },
  mounted() {
    this.langSet = this.$language;
  },
  methods: {
    //25.9.30 跳转详情 dxm
    toDetails(e) {
      this.$router.push({
        path: "/companyDetails",
        query: {
          id: e.exhibitor_long_id,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.popularity-wrap {
  margin-bottom: 120px;
}
.popular-list {
  width: 760px;
  height: 1003px;
  padding: 153px 0 0 40px;
  box-sizing: border-box;
  background: #f9fafc url("../../../assets/popu_bg.jpg") no-repeat;
  background-size: 100% 100%;
  border-radius: 40px;
  .popu-item {
    width: 620px;
    height: 70px;
    padding: 0 20px;
    box-sizing: border-box;
    background: #fff;
    margin-bottom: 10px;
    border-radius: 35px;
    cursor: pointer;
    border: 1px solid rgba(29, 35, 121, 0.12);
    .pop-logo {
      width: 98px;
      height: 52px;
      .img {
        max-width: 100%;
        max-height: 100%;
      }
    }
    .rank {
      width: 30px;
      height: 30px;
      font-size: 24px;
      color: #fff;
      background: #ff963a;
      text-align: center;
      line-height: 30px;
      border-radius: 50%;
      margin-right: 20px;
    }
    .p-name {
      flex: 1;
      cursor: pointer;
      padding-left: 20px;
      &:hover {
        color: #1d2379;
      }
    }
    .p-num {
      width: 100px;
      height: 38px;
      font-size: 14px;
      color: #1d2379;
      line-height: 38px;
      text-align: center;
      background: #fff;
      border-radius: 19px;
      border: 1px solid rgba(29, 35, 121, 0.48);
    }
  }
}
.popular-listen {
  background: #f9fafc url("../../../assets/popu_ebg.jpg") no-repeat;
  background-size: 100% 100%;
}
.popular-right {
  flex: 1;
  font-size: 24px;
  color: #001a33;
  line-height: 46px;
  padding-top: 200px;
  position: relative;
  .popu-intro {
    padding: 0 40px;
  }
  .popu-intro-en{
    font-size: 18px;
    line-height: 33px;
  }
  .popu-ewm {
    position: absolute;
    bottom: 100px;
    left: -60px;
    z-index: 9;
    width: 560px;
    height: 380px;
    font-size: 20px;
    color: #001a33;
    line-height: 30px;
    padding-top: 39px;
    box-sizing: border-box;
    background: #fff;
    box-shadow: 0px 12px 48px 0px rgba(0, 34, 99, 0.05);
    border-radius: 100px 30px 100px 30px;
    text-align: center;
  }
}
@media only screen and (max-width: 1280px) {
  .popular-list {
    width: 580px;
    height: 823px;
    padding-top: 120px;
    .popu-item {
      width: 90%;
      height: 58px;
      .el-image {
        height: 32px !important;
      }
      .p-name {
        font-size: 13px;
      }
      .p-num {
        width: 80px;
        height: 34px;
        line-height: 34px;
        font-size: 13px;
      }
    }
  }
  .popular-right {
    font-size: 22px;
    line-height: 38px;
    padding-top: 140px;
    .popu-ewm {
      width: 90%;
      height: auto;
      padding: 20px 0;
      left: -6%;
      overflow: hidden;
    }
  }
}
@media only screen and (max-width: 767px) {
  .popularity-wrap {
    flex-wrap: wrap;
    margin-bottom: 0.9rem;
    .popular-list {
      width: 100%;
      height: auto;
      padding: 1.3rem 0.38rem 0.58rem;
      background-size: contain;
      .popu-item {
        width: 100%;
        height: 1.69rem;
        padding: 0 0.19rem;
        border-radius: 0.38rem;
        position: relative;
        .rank {
          width: 0.46rem;
          height: 0.46rem;
          font-size: 0.3rem;
          line-height: 0.46rem;
          margin-right: 0.12rem;
        }
        .pop-logo {
          width: 2.08rem;
          height: 1.12rem;
        }
        .p-name {
          font-size: 0.29rem;
          line-height: 0.4rem;
          padding-left: 0.1rem;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          margin-bottom: 25px;
        }
        .p-num {
          position: absolute;
          right: 1.5rem;
          bottom: 0.3rem;
          width: 1.5rem;
          height: 0.46rem;
          line-height: 0.46rem;
        }
      }
    }
    .popular-right {
      width: 100%;
      padding-top: 0.58rem;
      .popu-intro {
        font-size: 0.29rem;
        line-height: 0.46rem;
      }
      .popu-ewm {
        left: 0;
        bottom: 0;
        width: 6.73rem;
        height: 5.38rem;
        font-size: 0.29rem;
        line-height: 0.46rem;
        margin: 0.58rem auto 0;
        position: relative;
        padding: 0.58rem 0 0;
        .el-image {
          width: 3.08rem !important;
          height: 3.12rem !important;
        }
      }
    }
  }
}
</style>